require('./ProgramHeader.scss');

const b = require('app/www/libs/b')('program-header');

const React = require('react');
const PropTypes = require('prop-types');

const {withReq} = require('app/www/components/contexts/Req');
const {withI18n} = require('app/www/components/contexts/I18n');

const Button_Broadcasting = require('app/www/components/blocks/Button/_Broadcasting/Button_Broadcasting');
const Button_Episodes = require('app/www/components/blocks/Button/_Episodes/Button_Episodes');
const Button_WatchEpisode = require('app/www/components/blocks/Button/_WatchEpisode/Button_WatchEpisode');
const Button_WatchOnline = require('app/www/components/blocks/Button/_WatchOnline/Button_WatchOnline');
const Button_WannaSee = require('app/www/components/blocks/Button/_WannaSee/Button_WannaSee');
const Ua = require('app/www/components/blocks/Ua/Ua');

const TITLE_LENGTH = 20;

class ProgramHeader extends React.PureComponent {

    render() {
        const {
            req,
            i18n,
            type,
            title,
            children,
            eventId,
            programId,
            isFavorite,
            ottSelection,
            episodesLength,
            isLayoutColumnsSmall,
            onClickButtonEpisodes,
            buttonBroadcastingProps,
            onClickButtonWatchOnline,
            onClickButtonBroadcasting,
            onClickButtonWatchEpisode,
        } = this.props;

        const {isFilm, isSerial, alias} = type;

        const hasBroadcasting = Boolean(buttonBroadcastingProps);
        const showWatchOnlineButton = Ua.displayWidth && !isLayoutColumnsSmall && Boolean(ottSelection && ottSelection.contentGroupUuid);
        const showBroadcastingButton = !showWatchOnlineButton && hasBroadcasting;
        const showWannaSeeButton = Ua.displayWidth && !req.lib('urlBuilder').isSerpApp;
        const showWatchEpisodesButton = Ua.displayWidth && isLayoutColumnsSmall && episodesLength > 1;
        const showWatchEpisodeButton = !showWatchOnlineButton && !hasBroadcasting && episodesLength > 0;
        const isWannaSeeButtonCollapsed = isLayoutColumnsSmall || hasBroadcasting || showWatchOnlineButton || episodesLength > 0;
        const showButtons = showWatchOnlineButton || showBroadcastingButton || showWatchEpisodesButton || showWatchEpisodeButton || !isWannaSeeButtonCollapsed;

        let titleAttrType = '';

        if (!isFilm && !hasBroadcasting) {
            const i18nKey = isSerial ? alias : 'other';
            titleAttrType = i18n.get(`button.broadcasting.title-attr.type.${i18nKey}`);
        }

        const titleAttr = i18n.get('button.broadcasting.title-attr.typed-value', {title, type: titleAttrType});

        const mod = {
            big: title.length < TITLE_LENGTH,
        };

        const iconPlay = {
            play: true,
            size: 'm',
        };

        if (hasBroadcasting) {
            Object.assign(buttonBroadcastingProps, {
                mods: {
                    theme: 'action',
                    size: 'l',
                    header: true,
                },
                attrs: {
                    title: titleAttr,
                },
                icon: {
                    size: 'm',
                },
                tooltipProps: false,
                children: i18n.get('button.broadcasting.program-header'),
                onClick: onClickButtonBroadcasting,
                streamLocation: 'programpage',
            });
        }

        const buttonWatchOnlineProps = {
            mods: {
                theme: 'action',
                size: 'l',
                header: true,
            },
            attrs: {
                title: titleAttr,
            },
            eventId,
            programId,
            ottSelection,
            icon: iconPlay,
            fromBlock: 'program',
            onClick: onClickButtonWatchOnline,
        };

        const buttonWatchEpisodeProps = {
            mods: {
                theme: 'action',
                size: 'l',
                header: true,
            },
            attrs: {
                title: titleAttr,
            },
            programId,
            icon: iconPlay,
            programType: type,
            programTitle: title,
            onClick: onClickButtonWatchEpisode,
        };

        const buttonEpisodesProps = {
            mods: {
                theme: 'grey',
                size: 'l',
            },
            attrs: {
                title: titleAttr,
            },
            onClick: onClickButtonEpisodes,
        };

        const buttonWannaSeeProps = Object.assign({
            mods: {
                theme: 'grey',
                size: 'l',
                'only-icon': isWannaSeeButtonCollapsed,
                header: true,
            },
            attrs: {
                title: titleAttr,
            },
            icon: {
                size: 'm',
                'wanna-see': true,
            },
            programId,
            isFavorite,
        }, !isWannaSeeButtonCollapsed && {
            tooltipProps: false,
        });

        return (
            <div className={b()}>
                <h1 className={b('title', mod)} itemProp="name">{title}</h1>
                {children}
                <div className={b('buttons', {expanded: showButtons})}>
                    {showWatchOnlineButton && (
                        <Button_WatchOnline {...buttonWatchOnlineProps} />
                    )}
                    {showBroadcastingButton && (
                        <Button_Broadcasting {...buttonBroadcastingProps} />
                    )}
                    {showWatchEpisodeButton && (
                        <Button_WatchEpisode {...buttonWatchEpisodeProps} />
                    )}
                    {showWannaSeeButton && (
                        <Button_WannaSee {...buttonWannaSeeProps} />
                    )}
                    {showWatchEpisodesButton && (
                        <Button_Episodes {...buttonEpisodesProps} />
                    )}
                </div>
            </div>
        );
    }
}

ProgramHeader.propTypes = {
    type: PropTypes.object,
    title: PropTypes.string,
    eventId: PropTypes.number,
    programId: PropTypes.number,
    isFavorite: PropTypes.bool,
    ottSelection: PropTypes.object,
    episodesLength: PropTypes.number,
    isLayoutColumnsSmall: PropTypes.bool,
    onClickButtonEpisodes: PropTypes.func,
    onClickButtonWatchOnline: PropTypes.func,
    onClickButtonBroadcasting: PropTypes.func,
    onClickButtonWatchEpisode: PropTypes.func,
    buttonBroadcastingProps: PropTypes.object,
};

module.exports = withReq(withI18n(ProgramHeader));
